/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import {convertSvgToDataUri} from '@ion/core/src/utils/Encoding';
import {dlsColor} from '@ion/dls/src/theme/theme';

export interface AssetStopEventOffsetUSMarker {
  width?: number,
  height?: number,
  fillColor?: string
};

/**
 * Utility function that returns an image from SVG that can be passed
 * to the esri Graphic constructor to make a graphic with Offset for stop(destination) of the trip
 *
 * ```typescript
 *  import {getAssetStopEventOffsetUSMarker} from '@ion/dls/src/maps/markers';
 *
 *  return {
 *    type   : 'picture-marker',
 *    url    : getAssetStopEventOffsetUSMarker({fillColor, width, height}),
 *    width  : width,
 *    height : height
 * }
 * ```
 */
export const getAssetStopEventOffsetUSMarker = ({
  fillColor = dlsColor('grey4'),
  width = 50,
  height = 51
}: AssetStopEventOffsetUSMarker) => {
  const svg = (`
    <svg width='${width}' height='${height}' viewBox='0 0 50 48' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M38 13.25C43.9371 13.25 48.75 18.0629 48.75 24C48.75 25.5511 48.0638 27.6177 47.124 29.7568C46.1707 31.9267 44.9051 34.2809 43.6484 36.4473C42.3903 38.6162 41.1334 40.6101 40.1914 42.0605C39.7203 42.7859 39.3271 43.3767 39.0518 43.7861C38.9142 43.9907 38.8055 44.1502 38.7314 44.2588C38.6946 44.3129 38.6668 44.3547 38.6475 44.3828C38.6378 44.3969 38.63 44.4078 38.625 44.415C38.6226 44.4185 38.6204 44.421 38.6191 44.4229C38.6185 44.4238 38.6185 44.4253 38.6182 44.4258H38.6172L38 45.3193L37.3828 44.4258H37.3818C37.3815 44.4253 37.3815 44.4238 37.3809 44.4229C37.3796 44.421 37.3774 44.4185 37.375 44.415C37.37 44.4078 37.3622 44.3969 37.3525 44.3828C37.3332 44.3547 37.3054 44.3129 37.2686 44.2588C37.1945 44.1502 37.0858 43.9907 36.9482 43.7861C36.6729 43.3767 36.2797 42.7859 35.8086 42.0605C34.8666 40.6101 33.6097 38.6162 32.3516 36.4473C31.0949 34.2809 29.8293 31.9267 28.876 29.7568C27.9362 27.6177 27.25 25.5511 27.25 24C27.25 18.0629 32.0629 13.25 38 13.25Z' fill='${fillColor}' stroke='white' stroke-width='1.5'/>
      <circle cx='38' cy='24' r='5' fill='white'/>
    </svg>
  `);
  return convertSvgToDataUri(svg.trim());
};

export default getAssetStopEventOffsetUSMarker;
